import {FC, memo, ReactNode} from "react";
import classnames from "classnames";
import {RxCross2} from "react-icons/rx";
import {ReducerState} from "../../store/reducer";
import {useStateValue} from "../state-provider/StateProvider";
import {setGridAreaContent} from "../app/App.action";
import './GridAreaContent.css'

const GridAreaContentComponent: FC<{
  requiredGridAreaContent: ReducerState['gridAreaContent'],
  content: ReactNode,
  openAreaUponClose?: ReducerState['gridAreaContent'],
}> = ({
  requiredGridAreaContent,
  content,
  openAreaUponClose = 'Grid',
}) => {

  const [{ gridAreaContent }, dispatch] = useStateValue()

  return (
    <>
      <div
        className={classnames('grid-area-content', {
          show: gridAreaContent === requiredGridAreaContent,
        })}
      >
        <RxCross2
          size={24}
          onClick={() => dispatch(setGridAreaContent(openAreaUponClose))}
          className="grid-area-content-close-button"
        />
        { content }
      </div>
    </>
  )
}

export const GridAreaContent = memo(GridAreaContentComponent)